<h2 mat-dialog-title>
  <mat-icon class="title-icon">inventory</mat-icon>
  Assign Lot Number
</h2>

<mat-dialog-content>
  <p class="dialog-subtitle">
    Assign a lot number to pending inventory from
    <strong>PO #{{ data.purchaseOrderNumber || data.purchaseOrderId }}</strong>.
  </p>

  <mat-divider class="section-divider"></mat-divider>

  <!-- Product Selection -->
  <h3 class="section-label">Product</h3>
  <mat-form-field appearance="outline" class="full-width"  *ngIf="false">
    <mat-label>Product (by Catalog #)</mat-label>
    <mat-icon matPrefix>inventory_2</mat-icon>
    <input matInput
           [formControl]="productSearch"
           placeholder="Search by catalog # or product name"
           [matAutocomplete]="autoProduct">
    <button mat-icon-button matSuffix
            *ngIf="productSearch.value"
            (click)="clearProduct()"
            type="button"
            matTooltip="Clear">
      <mat-icon>close</mat-icon>
    </button>
    <mat-autocomplete #autoProduct="matAutocomplete"
                      [displayWith]="displayProduct.bind(this)"
                      (optionSelected)="onProductSelected($event.option.value)">
      <mat-option *ngFor="let p of filteredProducts | async" [value]="p">
        <span class="option-catalog">{{ p.catalogNum }}</span>
        <span class="option-name">&nbsp;&mdash;&nbsp;{{ p.name }}</span>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <div *ngIf="selectedProduct" class="selected-preview">
    <mat-icon>check_circle</mat-icon>
    <span>{{ selectedProduct.catalogNum }} &mdash; {{ selectedProduct.name }}</span>
  </div>

  <mat-divider class="section-divider"></mat-divider>

  <!-- Vendor Details -->
  <h3 class="section-label">Vendor Details</h3>

  <mat-form-field appearance="outline" class="full-width" *ngIf="false">
    <mat-label>Vendor</mat-label>
    <mat-icon matPrefix>store</mat-icon>
    <input matInput
           [formControl]="vendorSearch"
           placeholder="Search by vendor name"
           [matAutocomplete]="autoVendor">
    <button mat-icon-button matSuffix
            *ngIf="vendorSearch.value"
            (click)="clearVendor()"
            type="button"
            matTooltip="Clear">
      <mat-icon>close</mat-icon>
    </button>
    <mat-autocomplete #autoVendor="matAutocomplete"
                      [displayWith]="displayVendor.bind(this)"
                      (optionSelected)="onVendorSelected($event.option.value)">
      <mat-option *ngFor="let v of filteredVendors | async" [value]="v">
        {{ v.name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <div *ngIf="selectedVendor" class="selected-preview vendor-preview">
    <mat-icon>check_circle</mat-icon>
    <span>{{ selectedVendor.name }}</span>
  </div>

  <div class="form-row" [formGroup]="form">
    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Vendor Catalog #</mat-label>
      <mat-icon matPrefix>tag</mat-icon>
      <input matInput formControlName="vendorCatalogNum" placeholder="Vendor's catalog number" [readonly]="true">
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field">
      <mat-label>Vendor Lot #</mat-label>
      <mat-icon matPrefix>qr_code_2</mat-icon>
      <input matInput formControlName="vendorLotNum" placeholder="Vendor's lot number">
    </mat-form-field>
  </div>

  <mat-divider class="section-divider"></mat-divider>

  <!-- Lot Number Form -->
  <h3 class="section-label">Lot Number Details</h3>

  <form [formGroup]="form" autocomplete="off">

    <div class="form-row lot-number-row">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Lot Number</mat-label>
        <mat-icon matPrefix>qr_code</mat-icon>
        <input matInput formControlName="lotNumber" placeholder="e.g. LOT-2024-001">
        <mat-error *ngIf="form.get('lotNumber')?.hasError('required')">Lot number is required</mat-error>
      </mat-form-field>
      <button mat-icon-button type="button" color="primary"
              (click)="fetchLatestLotNumber()"
              matTooltip="Suggest next lot number">
        <mat-icon>autorenew</mat-icon>
      </button>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Quantity Received</mat-label>
        <input matInput type="number" formControlName="quantityReceived" placeholder="0" step="0.01">
        <mat-error *ngIf="form.get('quantityReceived')?.hasError('required')">Required</mat-error>
        <mat-error *ngIf="form.get('quantityReceived')?.hasError('min')">Must be ≥ 0</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Unit Type</mat-label>
        <mat-select formControlName="unitType" [disabled]="true">
          <mat-option *ngFor="let u of unitTypes" [value]="u">{{ u }}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('unitType')?.hasError('required')">Required</mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Concentration</mat-label>
        <input matInput type="number" formControlName="concentration" placeholder="0.00" step="0.01">
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Activity Type</mat-label>
        <mat-select formControlName="activityType">
          <mat-option [value]="''">None</mat-option>
          <mat-option *ngFor="let at of activityTypes" [value]="at.value">{{ at.displayName }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="form-row" *ngIf="false">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Unit Price</mat-label>
        <span matPrefix>$&nbsp;</span>
        <input matInput type="number" formControlName="unitPrice" placeholder="0.00" step="0.01" [readonly]="true">
        <mat-error *ngIf="form.get('unitPrice')?.hasError('required')">Required</mat-error>
        <mat-error *ngIf="form.get('unitPrice')?.hasError('min')">Must be ≥ 0</mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Manufacturing Date</mat-label>
        <input matInput [matDatepicker]="mfgPicker" formControlName="manufacturingDate">
        <mat-datepicker-toggle matSuffix [for]="mfgPicker"></mat-datepicker-toggle>
        <mat-datepicker #mfgPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Expiration Date</mat-label>
        <input matInput [matDatepicker]="expPicker" formControlName="expirationDate">
        <mat-datepicker-toggle matSuffix [for]="expPicker"></mat-datepicker-toggle>
        <mat-datepicker #expPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Notes</mat-label>
      <textarea matInput formControlName="notes" rows="2" placeholder="Optional notes about this lot"></textarea>
    </mat-form-field>

  </form>

  <p *ngIf="errorMessage" class="error-message">
    <mat-icon>error_outline</mat-icon>
    {{ errorMessage }}
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" type="button"
          [disabled]="!selectedProduct || isSaving"
          (click)="save()">
    <mat-spinner *ngIf="isSaving" diameter="18" class="inline-spinner"></mat-spinner>
    {{ isSaving ? 'Saving…' : 'Assign Lot Number' }}
  </button>
</mat-dialog-actions>
